import { InputTextWebElementBase } from './InputTextWebElementBase';
import { By, Key } from 'selenium-webdriver';

/**
 * The component WebElement for [oj-c-input-text](../../jsdocs/oj-c.InputText.html).
 * Do not instantiate this class directly, instead, use
 * [findInputText](../functions/findInputText.html).
 */
export class InputTextWebElement extends InputTextWebElementBase {
  /**
   * Sets the value of the "value" property of the input component.
   * @param value The value to set for the <code>value</code>
   */
  public async changeValue(value: string | number | null): Promise<void> {
    const readonly = await this.getReadonly();
    const disabled = await this.getDisabled();
    if (!(disabled || readonly)) {
      await this.getDriver().executeScript((el: HTMLElement) => el.focus(), this);
      await this.whenBusyContextReady();

      // Note that using element.clear() will blur, which commits the change and calls
      // onValueChanged, which we don't want until we're done updating the value.
      // Instead do select-all, then delete to clear the value.
      const input = await this.findElement(By.css('input'));
      const currValue = await this.getRawValue();
      if (currValue) {
        const platform = await (await this.getDriver().getCapabilities()).getPlatform();
        await input.sendKeys(platform === 'mac' ? Key.COMMAND : Key.CONTROL, 'a');
        await input.sendKeys(Key.DELETE);
      }
      value !== null && (await input.sendKeys(value));

      return this.getDriver().executeScript((el: any) => el.validate(), this);
    }
  }

  /**
   * Clears the value of the component.
   */
  clear(): Promise<void> {
    return this.changeValue(null);
  }
}
